import React from "react";

type ButtonVariant = "danger" | "ghost" | "primary" | "secondary" | "success";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean;
  variant?: ButtonVariant;
}

const variantStyles: Record<ButtonVariant, React.CSSProperties> = {
  danger: {
    backgroundColor: "var(--status-error)",
    color: "var(--ink-inverse)",
  },
  ghost: {
    backgroundColor: "transparent",
    color: "var(--ink-base)",
  },
  primary: {
    backgroundColor: "var(--accent-primary)",
    color: "var(--ink-inverse)",
  },
  secondary: {
    backgroundColor: "var(--surface-tertiary)",
    color: "var(--ink-base)",
  },
  success: {
    backgroundColor: "var(--status-success)",
    color: "var(--ink-inverse)",
  },
};

const variantHoverClasses: Record<ButtonVariant, string> = {
  danger: "hover:opacity-90 active:opacity-80",
  ghost: "hover:bg-gray-100 active:bg-gray-200",
  primary: "hover:opacity-90 active:opacity-80",
  secondary: "hover:opacity-90 active:opacity-80",
  success: "hover:opacity-90 active:opacity-80",
};

export const Button: React.FC<ButtonProps> = ({
  children,
  className = "",
  disabled,
  isLoading = false,
  variant = "primary",
  ...props
}) => {
  return (
    <button
      className={`
        px-4 py-2 rounded-md font-medium text-sm
        transition-all duration-150
        disabled:cursor-not-allowed disabled:opacity-50
        ${variantHoverClasses[variant]}
        ${className}
      `}
      disabled={disabled || isLoading}
      style={variantStyles[variant]}
      {...props}
    >
      {isLoading ? (
        <span className="flex items-center gap-2">
          <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
            <circle
              className="opacity-25"
              stroke="currentColor"
              strokeWidth="4"
              fill="none"
              cx="12"
              cy="12"
              r="10"
            />
            <path
              className="opacity-75"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              fill="currentColor"
            />
          </svg>
          <span>Загрузка...</span>
        </span>
      ) : (
        children
      )}
    </button>
  );
};
